<template>
    <Button
        @click="isOpen = true"
        iconName="plus"
        color="light"
    >
        Create
    </Button>

    <Drawer
        @close="isOpen = false"
        :show="isOpen"
    >
        <template #title> Create </template>
        <template #content>
            <ApiForm
                :url="urlFactory.makeServicePriceStoreUrl(service.id)"
                method="POST"
                ref="apiFormRef"
            >
                <ServicePriceForm
                    :errors="
                        apiFormRef?.response?.getErrors() ??
                        new ApiFormErrors({})
                    "
                />
            </ApiForm>
        </template>
        <template #actions>
            <Button
                @click="isOpen = false"
                color="light"
            >
                Cancel
            </Button>
            <Button
                @click="submit"
                iconName="save"
                :loading="apiFormRef?.loading.valueOf()"
            >
                Save
            </Button>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ServicePriceForm from '@/App/Service/Component/ServicePrice/ServicePriceForm.vue'
    import Service from '@/App/Service/Entity/Service'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'

    const emits = defineEmits<{
        onSuccess: [ServiceAggregate]
    }>()

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
    })

    const isOpen = ref<boolean>(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                emits(
                    'onSuccess',
                    response.getHydratedServiceAggregate(
                        ResponseJsonKeyEnum.App_ServicePrices_Store_ServiceAggregateData,
                    ),
                )
            })
            ?.finally(() => {
                isOpen.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
